import { ResourceOptions } from 'react-admin';
import { FaMedal } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxLeaderboard;
export const icon = FaMedal;
export const options: ResourceOptions = {
  label: 'module.blindBox.leaderboard',
};
